import React from "react";
import styles from "./pp.module.css";

const PrivacyPolicy = () => {
  return (
    <div className={styles.pp_container}>
      <h3>General Terms of Use</h3>
      <div className={styles.privacycontainer}>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Publication</h2>
          <p className={styles.pp_container_p}>
            This site is published by:
            <br />
            <strong>BUSINESSCORNERS SAS</strong> with a capital of €1,000
            <br />
            22 Bis avenue du mai 1945, 95200, Sarcelles
            <br />
            {/* Phone: 00 00 00 00 00
            <br /> */}
            Pontoise RCS: SIREN No. 939 924 809 00014
            <br />
            Intra-community VAT: FR56939924809
            <br />
            The Publishing Director is HAQUE Fahinur
            <br />
            fahinur@businesscorners.online
          </p>
        </div>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Design</h2>
          <p className={styles.pp_container_p}>
            The site was designed and developed by:
            <br />
            <strong>COMMUNICATION</strong>
            <br />
            22 Bis avenue du mai 1945
            <br />
            Phone: +33 07 53 10 34 16
            <br />
            {/* Paris RCS: 000 000 000
            <br /> */}
            Contact: contact@businesscorners.online
          </p>
        </div>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Hosting</h2>
          <p className={styles.pp_container_p}>
            This site is hosted by:
            <br />
            <strong>HOSTINGER INTERNATIONAL LTD</strong>
            <br />
            21 Rue de La Banque, 75002 Paris, France
          </p>
        </div>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Privacy Policy</h2>
          <p className={styles.pp_container_p}>
            This privacy policy outlines how Business Corners collects, uses,
            discloses, and protects your personal data when you visit or
            interact with our website, platform, and services. By using our
            services, you agree to the collection and use of your personal
            information as described in this Privacy Policy.
          </p>
        </div>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Data Collection</h2>
          <p className={styles.pp_container_p}>
            We may collect the following types of personal data:
            <ul className={styles.pp_container_ul}>
              <li>
                Personal Information: Name, email, phone number, and company
                details.
              </li>
              <li>Account Information: Username and password.</li>
              <li>Service Data: Order history and inquiries.</li>
              <li>
                Technical Data: IP address, browser type, and operating system.
              </li>
            </ul>
          </p>
        </div>
        <div className={styles.section}>
          <h2 className={styles.pp_container_h2}>Cookies</h2>
          <p className={styles.pp_container_p}>
            Cookies are small text files stored on your device that help us
            analyze website traffic and improve your user experience.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
